import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
`;
export const Item = styled.div<any>`
  padding: 0 12px;

  &:hover {
    cursor: pointer;

    a {
      color: #2d3540;
    }
  }

  a {
    font-size: 16px;
    line-height: 26px;
    padding-bottom: 12px;
    padding-top: 12px;
    color: #6c7279;
  }

  a.active {
    font-weight: bold;
    color: #f4534a;
    border-bottom: 2px solid #f4534a;
  }
`;
